import Scene from "~/scene";
import { htmlToImage } from "~/hti";
import { detect } from "detect-browser";
import { node } from "~/util/dom";

function prepareImage() {
	return new Promise(resolve => {
		const pano = Mapy.getComponent("pano");

		if (pano.isActive()) {
			const panoCont = pano.getContainer();
			const canvas = panoCont.querySelector("canvas");
			const browser = detect();

			if (browser.name === "safari") {
				const panoState = pano.getState();
				const pitch = panoState.pitch ? `&pitch=${panoState.pitch}` : "";
				const yaw = panoState.yaw ? `&yaw=${panoState.yaw}` : "";
				const src = `//panorama-mapserver.mapy.cz/compose_pano?w=${Math.min(2000, canvas.offsetWidth)}&h=${Math.min(2000, canvas.offsetHeight)}&pid=${panoState.pid}&fov=${panoState.fov}${pitch}${yaw}`;
				const img = node("img", { id: "panoPrintImg", src, width: canvas.offsetWidth, height: canvas.offsetHeight, crossOrigin: "anonymous" });

				img.style.position = "absolute";
				img.style.top = "0";
				img.style.left = "0";

				img.onload = () => {
					resolve({});
				};
				panoCont.insertBefore(img, panoCont.firstChild.nextSibling);
			} else {
				pano.getDataUrl().then(data => {
					if (canvas) {
						const img = node("img", { id: "panoPrintImg", src: data, width: canvas.offsetWidth, height: canvas.offsetHeight });

						img.style.position = "absolute";
						img.style.top = "0";
						img.style.left = "0";

						panoCont.insertBefore(img, panoCont.firstChild.nextSibling);
					}

					resolve({});
				}, () => {});
			}
		} else if (Scene.isM3dActive()) {
			const img = node("img", { id: "m3dPrintImg", src: Scene.get3dScreenshot(false).src, crossOrigin: "anonymous" });

			img.style.position = "absolute";
			img.style.top = "0";
			img.style.left = "0";

			Scene.getContainer().appendChild(img);
			resolve({});
		} else {
			resolve({});
		}
	});
}

function downloadAsImageRemoveLoader() {
	Mapy.getComponent("print").returnAfterPrint();

	if (Mapy.getComponent("loader").getBigCon().parentNode === document.body) {
		Mapy.getComponent("loader").getBigCon().remove();
	}

	Mapy.getComponent("loader").end(true);
}

export async function downloadAsImage() {
	// add loader
	document.body.appendChild(Mapy.getComponent("loader").getBigCon());
	Mapy.getComponent("loader").start(true);
	Mapy.getComponent("print").prepare(4);

	try {
		await prepareImage();
		const imgData = await htmlToImage();

		if (Mapy.getComponent("pano").isActive()) {
			const panoImgReplace = document.getElementById("panoPrintImg");

			panoImgReplace?.remove();
		}

		if (Scene.isM3dActive()) {
			const m3dImg = document.getElementById("m3dPrintImg");

			if (m3dImg) {
				m3dImg.remove();
			}
		}

		downloadAsImageRemoveLoader();
		Mapy.Util.startBlobDownload(Mapy.Util.dataURItoBlob(imgData), "mapy.png");
	} catch (exc) {
		/* eslint-disable no-console */
		console.log(exc);
		downloadAsImageRemoveLoader();
	}
}
